module.exports = __webpack_public_path__ + "img/header.0631e2af.jpg";